import { FieldValues, UseFormReturn } from "react-hook-form";

export const resetFormStateAndKeepFormValues = <TFieldValues extends FieldValues>(
  methods: UseFormReturn<TFieldValues>
) => {
  const formValues = methods.getValues();

  methods.reset(formValues, { keepValues: true });
};
